<template>
  <ul class="sidebar-menu">
    <li class="header">HOME</li>
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Dashboard</span>
      </a>
    </router-link>

    <li class="header"
      v-if="hasPermission('CAN_CREATE_MERCHANT') ||
            hasPermission('CAN_APPROVE_MERCHANT') ||
            hasPermission('CAN_VIEW_MERCHANT')
      ">
      Merchants
    </li>
    <router-link tag="li" class="pageLink" to="/merchant/create" v-if="hasPermission('CAN_CREATE_MERCHANT')">
      <a>
        <i class="fa fa-pencil-square"></i>
        <span class="page">Create Merchant</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/merchant/approve"  v-if="hasPermission('CAN_APPROVE_MERCHANT')">
      <a>
        <i class="fa fa-tasks"></i>
        <span class="page">Approve Merchants</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/merchant/view" v-if="hasPermission('CAN_VIEW_MERCHANT')">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">View Merchants</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/merchant/requests" v-if="hasPermission('CAN_CREATE_MERCHANT') || hasPermission('CAN_APPROVE_MERCHANT')">
      <a>
        <i class="fa fa-tasks"></i>
        <span class="page">Merchant Creation Requests</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/bulk_upload" v-if="hasPermission('CAN_VIEW_BULK') || hasPermission('CAN_UPLOAD_BULK')">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">Bulk Uploads</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/bulk_upload_approve" v-if="hasPermission('CAN_APPROVE_BULK')">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">Bulk Uploads Approval</span>
      </a>
    </router-link>

    <li class="header"
      v-if="hasPermission('CAN_APPROVE_STORE')">
      Stores
    </li>
    <router-link tag="li" class="pageLink" to="/merchant/stores/approve" v-if="hasPermission('CAN_APPROVE_STORE')">
      <a>
        <i class="fa fa-tasks"></i>
        <span class="page">Approve Store</span>
      </a>
    </router-link>

    <li class="header"
      v-if="hasStores()">
      Transactions
    </li>
    <router-link tag="li" class="pageLink" to="/merchant/pos_statement_today" v-if="hasStores()">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">Today's Card Transactions</span>
      </a>
    </router-link> 
    <router-link tag="li" class="pageLink" to="/merchant/pos_statement" v-if="hasStores()">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">Settled Card Transactions</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/merchant/mpesa_transaction" v-if="hasStores()">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">Mpesa Transactions</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/merchant/stkpush_transaction" v-if="hasStores()">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">STK Push Transactions</span>
      </a>
    </router-link>
    <!-- <router-link tag="li" class="pageLink" to="/merchant/transactions" v-if="hasStores()">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">POS Transaction Statements</span>
      </a>
    </router-link> -->
    <!-- <router-link tag="li" class="pageLink" to="/merchant/statement" v-if="hasStores()">
      <a>
        <i class="fa fa-eye"></i>
        <span class="page">Account Statements</span>
      </a>
    </router-link> -->
    <!-- Users -->
    <li class="header" v-if="hasPermission('CAN_CREATE_INTERNALUSERS') ||
            hasPermission('CAN_VIEW_INTERNALUSERS') ||
            hasPermission('CAN_APPROVE_INTERNALUSERS')
    ">
     Users
    </li>
    <li class="treeview" v-if="hasPermission('CAN_CREATE_INTERNALUSERS') ||
            hasPermission('CAN_VIEW_INTERNALUSERS') ||
            hasPermission('CAN_APPROVE_INTERNALUSERS') || hasPermission('CAN_APPROVE_EXTERNALUSERS')
      ">
      <a href="#">
        <i class="fa fa-users"></i>
        <span class="treeview-title">Internal Users</span>
        <span class="pull-right-container pull-right">
          <i class="fa fa-angle-left fa-fw"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/user/internal/create" v-if="hasPermission('CAN_CREATE_INTERNALUSERS')">
          <a>
            <i class="fa fa-pencil-square"></i>
            <span class="page">Create User</span>
          </a>
        </router-link>

        <router-link tag="li" class="pageLink" to="/user/internal/view" v-if="hasPermission('CAN_VIEW_INTERNALUSERS')">
          <a>
            <i class="fa fa-eye"></i>
            <span class="page">View Users</span>
          </a>
        </router-link>

        <router-link tag="li" class="pageLink" to="/user/internal/approve" v-if="hasPermission('CAN_APPROVE_INTERNALUSERS')">
          <a>
            <i class="fa fa-tasks"></i>
            <span class="page">Approve Users</span>
          </a>
        </router-link>
      </ul>
    </li>

    <li class="treeview" v-if="hasPermission('CAN_APPROVE_EXTERNALUSERS')">
     <a href="#">
        <i class="fa fa-users"></i>
        <span class="treeview-title">External Users</span>
        <span class="pull-right-container pull-right">
          <i class="fa fa-angle-left fa-fw"></i>
        </span>
     </a>
     <ul class="treeview-menu">
       <router-link tag="li" class="pageLink" to="/merchant/users/approve" v-if="hasPermission('CAN_APPROVE_EXTERNALUSERS')">
        <a>
          <i class="fa fa-tasks"></i>
          <span class="page">Approve External Users</span>
        </a>
       </router-link>
     </ul>
    </li>

    <router-link tag="li" class="pageLink" to="/user/requests"
        v-if="hasPermission('CAN_CREATE_INTERNALUSERS')
        || hasPermission('CAN_APPROVE_INTERNALUSERS')
        || hasPermission('CAN_CREATE_EXTERNALUSERS')
        || hasPermission('CAN_APPROVE_EXTERNALUSERS')  ">
      <a>
        <i class="fa fa-book"></i>
        <span class="page">User Creation Requests</span>
      </a>
    </router-link>

    <li class="header"
      v-if="hasPermission('CAN_CREATE_ROLE') ||
            hasPermission('CAN_VIEW_ROLE')
      ">
      Roles
    </li>

    <li class="treeview"
      v-if="hasPermission('CAN_CREATE_ROLE') ||
            hasPermission('CAN_VIEW_ROLE') ||
            hasPermission('CAN_APPROVE_ROLE')
      ">
      <a href="#">
        <i class="fa fa-folder-o"></i>
        <span class="treeview-title">Roles</span>
        <span class="pull-right-container pull-right">
          <i class="fa fa-angle-left fa-fw"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <router-link tag="li" class="pageLink" to="/admin/createrole" v-if="hasPermission('CAN_CREATE_ROLE')">
          <a>
            <i class="fa fa-pencil-square"></i>
            <span class="page">Create Role</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/viewroles" v-if="hasPermission('CAN_VIEW_ROLE')">
          <a>
            <i class="fa fa-eye"></i>
            <span class="page">View Roles</span>
          </a>
        </router-link>
        <router-link tag="li" class="pageLink" to="/admin/approverole" v-if="hasPermission('CAN_APPROVE_ROLE')">
          <a>
            <i class="fa fa-eye"></i>
            <span class="page">Approve Roles</span>
          </a>
        </router-link>
      </ul>
    </li>

    <li class="header"
      v-if="hasPermission('CAN_CREATE_PERMISSION') ||
            hasPermission('CAN_VIEW_PERMISSION')
      ">
      Permissions
    </li>

    <li class="treeview"
      v-if="hasPermission('CAN_CREATE_PERMISSION') ||
            hasPermission('CAN_VIEW_PERMISSION')
      ">
      <a href="#">
        <i class="fa fa-folder-o"></i>
        <span class="treeview-title">Permissions</span>
        <span class="pull-right-container pull-right">
          <i class="fa fa-angle-left fa-fw"></i>
        </span>
      </a>
      <ul class="treeview-menu">

        <router-link tag="li" class="pageLink" to="/permission/create" v-if="hasPermission('CAN_CREATE_PERMISSION')">
          <a>
            <i class="fa fa-pencil-square"></i>
            <span class="page">Create Permission</span>
          </a>
        </router-link>

        <router-link tag="li" class="pageLink" to="/permission/view" v-if="hasPermission('CAN_VIEW_PERMISSION')">
          <a>
            <i class="fa fa-eye"></i>
            <span class="page">View Permissions</span>
          </a>
        </router-link>
      </ul>
    </li>

    <li class="treeview"
      v-if="hasPermission('CAN_VIEW_SYSTEMSTATUS')
      ">
      <a href="#">
        <i class="fa fa-folder-o"></i>
        <span class="treeview-title">System Status</span>
        <span class="pull-right-container pull-right">
          <i class="fa fa-angle-left fa-fw"></i>
        </span>
      </a>
      <ul class="treeview-menu">

        <router-link tag="li" class="pageLink" to="/admin/systemstatus" v-if="hasPermission('CAN_VIEW_SYSTEMSTATUS')">
          <a>
            <i class="fa fa-pencil-square"></i>
            <span class="page">Database</span>
          </a>
        </router-link>
      </ul>
    </li>
    <li class="treeview"
      v-if="hasPermission('CAN_VIEW_NOTIFICATIONS')
      ">
      <a href="#">
        <i class="fa fa-folder-o"></i>
        <span class="treeview-title">Notifications</span>
        <span class="pull-right-container pull-right">
          <i class="fa fa-angle-left fa-fw"></i>
        </span>
      </a>
      <ul class="treeview-menu">

        <router-link tag="li" class="pageLink" to="/admin/tokennotification" v-if="hasPermission('CAN_VIEW_NOTIFICATIONS')">
          <a>
            <i class="fa fa-pencil-square"></i>
            <span class="page">User Reg Tokens</span>
          </a>
        </router-link>
      </ul>
    </li>
  </ul>
</template>
<script>
import store from '../store'
export default {
  name: 'SidebarMenu',
  data() {
    return {
      role: 'helpdesk',
      permissions: []
    }
  },
  methods: {
    hasPermission(permission) {
      return this.permissions.includes(permission)
    },
    hasStores() {
      let userStores = store.state.user.allStores
      if (userStores.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  mounted() {
    var localUserString = window.localStorage.getItem('user')
    var localUser = JSON.parse(localUserString)
    this.permissions = localUser.permissions
  }
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?13dc25b2